module.exports = __webpack_public_path__ + "img/aat_logo.28e91d24.jpg";